$(document).ready(function () {
  $('.block_video-section-grid-tab').click(function () {
      if ($(this).hasClass('block_video-section-grid-2')) {
          $('.block_video-section-bottom').addClass('grid-2-active');
      } else {
          $('.block_video-section-bottom').removeClass('grid-2-active');
      }
      $('.block_video-section-grid-tab').removeClass('video-grid-active');
      $(this).addClass('video-grid-active');
  });

$('.popup-youtube').magnificPopup({
    type: 'iframe',
    mainClass: 'mfp-fade',
    removalDelay: 160,
    preloader: false,
    fixedContentPos: false
});

$('.block_video-sec-bt-in-icon').magnificPopup({
      type: 'iframe',
      mainClass: 'mfp-fade',
      removalDelay: 160,
      preloader: false,
      fixedContentPos: false
  });  
  
  
// Video Play button
// let currentVideo = null;
// $('.block_video-sec-bt-in-videos-svg .video-svg-icon').click(function() {
//     const videoId = $(this).data('video-id');
//     const video = $('#' + videoId)[0];    
//     if (video.paused) {
//         video.play();
//         $(this).addClass('playing');        
//         $('video').not(video).each(function() {
//             this.pause();
//         });        
//         $('.block_video-sec-bt-in-videos-svg .video-svg-icon').not($(this)).removeClass('playing');        
//         currentVideo = video;
//     } else {
//         video.pause();
//         $(this).removeClass('playing');
//         currentVideo = null;
//     }
// });
// $('video').on('ended', function() {
//     $(this).prev().find('.block_video-sec-bt-in-videos-svg .video-svg-icon').removeClass('playing');
//     currentVideo = null;
// });
// $('.video').on('pause ended', function() {
//     $(this).prev().find('.block_video-sec-bt-in-videos-svg .video-svg-icon').removeClass('playing');
// });
  
// Mobile Search Button
  $('.video-wrapper-search-icon').click(function() {
    $(this).parent().toggleClass('searchbar-input-open');
  });
  
});

function MyVideoFunction() {
    var input, filter, faqContainers, i, j, h6, txtValue;
    input = document.getElementById("MyVideo");
    filter = input.value.toUpperCase();  
    faqContainers = document.getElementsByClassName("block_video-section-bottom");  
    for (i = 0; i < faqContainers.length; i++) {
        var faqBodies = faqContainers[i].getElementsByClassName("block_video-section-bt-inner-flex");
        for (j = 0; j < faqBodies.length; j++) {
            h6 = faqBodies[j].getElementsByClassName("h5")[0];
            if (h6) {
                txtValue = h6.textContent || h6.innerText;
                if (txtValue.toUpperCase().indexOf(filter) > -1) {
                    faqBodies[j].style.display = "";
                } else {
                    faqBodies[j].style.display = "none";
                }
            }
        }       
        if (filter.trim() === "") {
            faqContainers[i].style.display = "";
        } else {
            var allHidden = Array.from(faqBodies).every(body => body.style.display === "none");
            if (allHidden) {
                faqContainers[i].style.display = "none";
            } else {
                faqContainers[i].style.display = "";
            }
        }
    }
}
